import DefaultPayload from './core/DefaultPayload';

/**
 * Making sure that the source region is within the image
 * approximage calculations could get it slightly offside
 * so causing IndexSizeError in IE/Firefox
 */
export function normalizedContextDrawImage(
    context: CanvasRenderingContext2D,
    image: HTMLImageElement | HTMLCanvasElement,
    sx: number,
    sy: number,
    sWidth: number,
    sHeight: number,
    dx: number,
    dy: number,
    dWidth: number,
    dHeight: number
) {
    sx = Math.max(0, sx);
    sy = Math.max(0, sy);
    sWidth = Math.min(image.width - sx, sWidth);
    sHeight = Math.min(image.height - sy, sHeight);

    context.drawImage(image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight);
}
/**
 * Returns a payload that have an properly calculated zoom so that
 * image will fit in the given crop dimentions, either on width or on height
 * depending on the aspect ratio
 */
export function getFitPayload(width: number, height: number, cropWidth: number, cropHeight: number) {
    const payload = Object.assign({}, DefaultPayload);
    // if the image aspect is larger than the crop aspect
    // readjust the zoom so the image fits in the crop area without upscaling
    if (width / height > cropWidth / cropHeight) {
        payload.zoom = cropHeight / cropWidth * width / height;
    }
    return payload;
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/image-inline-editor/Utils.ts
 **/